import { createStyles, Grid, styled, Theme, Typography, withStyles } from '@material-ui/core';
import { Fragment } from 'react';

import { PageContent } from './PageContent';
import { PageLoader } from './PageLoader';
import { PaginationByPage } from './PaginationByPage';

import { Pagination } from '~models';
import { DataPlaceholder } from '~ui-kit';

const CountTitleTypography = styled(Typography)(({ theme }) => ({ marginBottom: theme.spacing(2) }));
const GridContainer = withStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'grid',
      paddingLeft: 12,
      justifyContent: 'space-between',
      width: '100%',
      '&:nth-child(n)': {
        marginBottom: '30px',
      },
    },
  })
)(Grid);

export interface PaginatedUIDataListProps<T> {
  data: T[];
  loading?: boolean;
  isUnitsList?: boolean;
  renderItem: (item: T, i: number) => unknown;
  onPaginationChange: (pagination: Pagination) => void;
  countTitle?: string;
  pagination: Pagination;
}

export const PaginatedUIDataList = <T extends unknown>({
  data,
  loading,
  isUnitsList,
  renderItem,
  onPaginationChange,
  countTitle = '',
  pagination,
}: PaginatedUIDataListProps<T>) => {
  const showPagination = pagination?.totalPages > 1;

  if (loading) {
    return (
      <PageContent>
        <PageLoader />
      </PageContent>
    );
  }

  return (
    <Fragment>
      {countTitle ? (
        <CountTitleTypography color="primary" variant="h3">
          {countTitle}
        </CountTitleTypography>
      ) : null}

      <PageContent>
        {data?.length ? (
          <GridContainer
            style={isUnitsList ? { gridTemplateColumns: 'repeat(10, 1fr)' } : { gridTemplateColumns: 'repeat(3, 1fr)' }}
          >
            {data.map(renderItem)}
          </GridContainer>
        ) : (
          <DataPlaceholder />
        )}
      </PageContent>

      {showPagination ? (
        <PaginationByPage pagination={pagination} loading={loading} onChange={onPaginationChange} />
      ) : null}
    </Fragment>
  );
};
